import { render, staticRenderFns } from "./SectionEditor.vue?vue&type=template&id=1a70bff2&scoped=true&"
import script from "./SectionEditor.vue?vue&type=script&lang=js&"
export * from "./SectionEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a70bff2",
  null
  
)

export default component.exports